import type { ApiErrorDetail } from './types'

export class ApiError extends Error {
  readonly code?: number | string
  readonly status?: number
  readonly data?: unknown

  constructor(detail: ApiErrorDetail) {
    super(detail.message)
    this.name = 'ApiError'
    this.code = detail.code
    this.status = detail.status
    this.data = detail.data
  }
}
